import type { ReactNode } from 'react';
import clsx from 'clsx';
import { useSidebarStore } from '@lib/store';
import { useResponsive } from '@shared/hooks';
import { PaletteUtils } from '@shared/utils';

interface HeaderProps {
  children?: ReactNode;
  action?: ReactNode;
}

export const Subheader = (props: HeaderProps) => {
  const sidebarStore = useSidebarStore();

  const { isSmallScreen } = useResponsive();

  return (
    <h1
      className={clsx(
        'text-xl flex justify-between text-[#dadada] mt-5 mb-6 items-center relative max-[840px]:h-15 max-[840px]:m-0 max-[840px]:pl-15 max-[840px]:bg-[#1e1e21] max-[840px]:text-center max-[840px]:fixed max-[840px]:top-0 max-[840px]:w-full max-[840px]:z-50  ',
        PaletteUtils.isBordierPalette && 'text-[22px] !text-[#4d3b2c]',
      )}
    >
      {isSmallScreen && sidebarStore.data && (
        <div className='absolute left-[-70px] pt-8 pr-[50px] cursor-pointer' onClick={() => sidebarStore.toggleSidebar()}>
          <svg className='block' xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='-7 -2 20 20'>
            <path fill='currentColor' d='M0 1.75L5.595 7.5 0 13.25 1.703 15 9 7.5 1.703 0z' />
          </svg>
        </div>
      )}
      <span className={clsx('text-xl tracking-[0.14px] max-[840px]:my-0 max-[840px]:mx-auto max-[840px]:pr-15 uppercase')}>{props.children}</span>
      <div className={'flex flex-basis-[60px] max-[840px]:pr-5'}>{props.action}</div>
    </h1>
  );
};
